import React from 'react';

import { StyleUtil } from 'ui/util';
import classNames from './EABDMovingStepIndicator.module.scss';

export interface MovingStepIndicatorProps {
  readonly currentStepIndex: number;
}

export const MovingStepIndicator = React.memo<MovingStepIndicatorProps>((props) => {
  const { currentStepIndex } = props;

  const HighlightedAtom = React.useMemo(() => {
    const highlightedAtomClassNames: string[] = [classNames.highlightedAtom];

    if (currentStepIndex > 0) {
      highlightedAtomClassNames.push(classNames.right);
    }

    return (
      <div className={StyleUtil.mergeClassNames(highlightedAtomClassNames)}>
        <div className={classNames.inner} />
      </div>
    );
  }, [currentStepIndex]);

  const Atom = React.useMemo(() => {
    const atomClassNames: string[] = [classNames.atom];

    if (currentStepIndex > 0) {
      atomClassNames.push(classNames.active);
    }

    return <div className={StyleUtil.mergeClassNames(atomClassNames)} />;
  }, [currentStepIndex]);

  const Line = React.useMemo(() => {
    const lineClassNames: string[] = [classNames.line];

    if (currentStepIndex > 0) {
      lineClassNames.push(classNames.active);
    }

    return <div className={StyleUtil.mergeClassNames(lineClassNames)} />;
  }, [currentStepIndex]);

  const MovingContainer = React.useMemo(() => {
    const marginLeftBaseValue = currentStepIndex ? currentStepIndex - 1 : 0;

    const movingContainerStyle: React.CSSProperties = {
      marginLeft: `${marginLeftBaseValue * 10}%`,
    };

    return (
      <div className={classNames.moving} style={movingContainerStyle}>
        {Atom}
        {Line}
        {Atom}
        {HighlightedAtom}
      </div>
    );
  }, [currentStepIndex, HighlightedAtom, Line, Atom]);

  return <div className={classNames.container}>{MovingContainer}</div>;
});
